/* eslint-disable i18next/no-literal-string */
import { cn } from "@ui/lib/utils";

export const SoundBoardLogo = ({ className }: { className?: string }) => {
  return (
    <div className={cn("flex flex-col gap-16", className)}>
      <svg fill='none' height='43' viewBox='0 0 154 43' width='154' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M49.8548 12.6471H33.0584C32.6766 9.25535 29.4701 7.76069 25.271 7.76069C20.6138 7.76069 17.7889 9.25535 17.7889 11.5548C17.7889 13.3369 19.3922 14.3717 24.5838 15.1765L30.5389 16.0963C45.2739 18.3957 51 21.9024 51 28.8008C51 37.7112 40.9222 43 25.6527 43C10.0015 43 0.610778 39.3783 0 29.1457H16.7964C17.1781 33.4572 20.4611 35.2393 25.5763 35.2393C30.6916 35.2393 33.6692 33.6297 33.6692 31.2152C33.6692 28.9158 31.5314 27.996 26.6452 27.2487L20.6901 26.3289C6.33683 24.0869 0.763473 20.0628 0.763473 13.4519C0.763473 5.11631 11.0704 0 25.271 0C40.5404 0 49.0913 4.3115 49.8548 12.6471Z'
          fill='black'
        />
        <path
          d='M55 1H81.6161C93.9005 1 101.104 4.5028 101.104 11.9678C101.104 15.93 98.2986 19.0882 94.128 20.8109V21.0406C98.981 22.3613 103 25.1751 103 30.3431C103 37.8081 96.0237 42 82.981 42H55V1ZM71.1517 16.9636H80.0237C82.6777 16.9636 84.7251 15.8151 84.7251 13.4034C84.7251 10.9916 82.6777 9.90056 80.0237 9.90056H71.1517V16.9636ZM86.6208 29.3095C86.6208 26.8403 84.6493 25.5196 81.6161 25.5196H71.1517V33.0994H81.6161C84.6493 33.0994 86.6208 31.7787 86.6208 29.3095Z'
          fill='black'
        />
        <path
          d='M125.247 1.5H138.848V33.0994V33.5994H139.348H153.5V41.5H106.5V33.5994H122.941H123.441V33.0994V17.423V16.923H122.941H110.01V10.4324C115.08 10.1468 118.572 9.31385 120.964 7.81957C123.351 6.32889 124.591 4.21541 125.247 1.5Z'
          stroke='black'
        />
      </svg>
      <span className='color-orange sb-color-orange font-bold'>サウンドボード</span>
    </div>
  );
};
